import courseraPlusProductVariants from 'bundles/coursera-plus-common/constants/CourseraPlusProductVariant';
import { useGetProductPrices } from 'bundles/ownable-products-common/hooks/useGetProductPrices';
import ProductType from 'bundles/payments-common/common/ProductType';

export const useGetCourseraPlusMonthlyUpsellProductPrice = ({ skip = false }: { skip?: boolean }) => {
  const courseraPlusMonthlyProductItemId = courseraPlusProductVariants.MONTHLY_UPSELL_UPGRADE;
  const products = [
    {
      productType: ProductType.COURSERA_PLUS_SUBSCRIPTION,
      productItemId: courseraPlusMonthlyProductItemId,
    },
  ];
  const {
    productPrices: courseraPlusMonthlyUpsellProductPrices,
    loading: loadingCourseraPlusMonthlyUpsellProductPrice,
  } = useGetProductPrices({ products, skip });

  return {
    courseraPlusMonthlyUpsellProductPrice: courseraPlusMonthlyUpsellProductPrices?.[0],
    loadingCourseraPlusMonthlyUpsellProductPrice,
  };
};
